<template>
  <div class="wrapper-transaksi-mesin">
    <div class="f-regular f-14 f-c-midgrey" v-if="!sw">
      Mesin standby — siap untuk digunakan.
    </div>
    <template v-else>
      <div class="f-regular f-14 f-c-midgrey">
        Transaksi yg berjalan di mesin ini
      </div>
      <div class="wrapper-detail">
        <div class="item-detail d-flex justify-content-between">
          <div class="f-regular f-16 f-c-black" v-if="layanan.data">
            <template v-if="layanan.data.id">
              <span v-if="layanan.data.id.includes('$')">{{
                layanan.data.layanan.nama_layanan
              }}</span>
              <span v-else>{{ layanan.data.nama }}</span>
            </template>
            <span v-else>SmartOwner</span>
          </div>
          <div class="f-regular f-16 f-c-black" v-else>Dinyalakan owner</div>
          <div class="f-regular f-16 f-c-midgrey">
            {{ this.formatMilisecond(time) }}
          </div>
        </div>
        <div class="item-detail">
          <template v-if="layanan.data">
            <div class="f-13 f-c-midgrey f-regular">
              ID Transaksi:
              {{ aid.includes("$") ? layanan.data.idtransaksi : aid }}
            </div>
          </template>
          <div class="f-13 f-c-midgrey f-regular" v-else>
            ID Transaksi: SmartLink
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "SOTransaksiDetailMesin",
  props: ["layanan", "aid", "id", "sw", "tl"],
  data() {
    return {
      time: 0,
      interval: null,
    };
  },
  watch: {
    sw: {
      handler: function (v, o) {
        if (v) {
          // this.getLayananAid()
          this.runTImer(this.tl);
        }
        if (o) {
          this.stopTimer();
        }
      },
    },
  },
  methods: {
    stopTimer() {
      clearInterval(this.interval);
    },

    runTImer(timeLeft) {
      this.time = timeLeft;
      this.interval = setInterval(() => {
        if (this.time > 0) {
          this.time -= 1000;
        } else {
          this.stopTimer();
        }
      }, 1000);
    },
  },
  mounted() {
    // this.getLayananAid()
    if (this.sw) {
      this.runTImer(this.tl);
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style scoped>
.wrapper-transaksi-mesin {
  padding: 20px;
}

.wrapper-detail {
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 34, 119, 0.06);
  border-radius: 5px;
  padding: 10px 18px;
}
</style>